import { WorkOrderModuleCategoriesSettings } from 'lane-shared/domains/workOrder';
import { TeamCoverageEntry } from './coverageHoursTeamUtils';
import { toProtoDayNames } from './coverageHoursRowFormat';
import { minutesOfDay } from './coverageHoursTimeUtils';
import { CreateCoverageHoursTeam } from './useCreateCoverageHours';
import { CoverageHoursIssueTypeOption } from './useCoverageHoursOptions';
import {
  resolveIssues,
  shouldCreateNoneWithAllIssueTypes,
} from './coverageHoursPanelUtils';

export type CoverageHoursSavePayload = {
  issues: string[];
  teams: CreateCoverageHoursTeam[];
  shouldAlsoCreateNone: boolean;
};

export function buildCoverageHoursSavePayload({
  issueTypeValue,
  selectedCategory,
  issueTypeOptions,
  savedTeams,
}: {
  issueTypeValue: string;
  selectedCategory: WorkOrderModuleCategoriesSettings | undefined;
  issueTypeOptions: CoverageHoursIssueTypeOption[];
  savedTeams: TeamCoverageEntry[];
}): CoverageHoursSavePayload {
  const issues = resolveIssues(
    issueTypeValue,
    selectedCategory,
    issueTypeOptions
  );

  const teamsWithBlocks = savedTeams.map(team => ({
    team,
    blocks: team.coverageBlocks.map(block => ({
      daysOfWeek: toProtoDayNames(block.daysOfWeek),
      startMinute: minutesOfDay(block.startTime),
      endMinute: minutesOfDay(block.endTime, block.startTime),
    })),
  }));

  const teams = teamsWithBlocks.map(({ team, blocks }) => ({
    teamId: team.teamId,
    blocks,
  }));

  // An empty `issues` call already creates the category-level routing itself,
  // so a second, separate None call is only needed when `issues` is non-empty.
  const shouldAlsoCreateNone =
    issues.length > 0 &&
    shouldCreateNoneWithAllIssueTypes(
      issueTypeValue,
      selectedCategory,
      issueTypeOptions
    );

  return { issues, teams, shouldAlsoCreateNone };
}
